import { Zap, Home, Grid3x3, Wind, Shield, Lightbulb, AlertCircle, Building2, Award, Clock, Users, CheckCircle2, Wrench, Plug, Hammer, BatteryCharging, Cpu, Sun, HardHat, Sparkles } from 'lucide-react';

export const iconMap = {
  Zap, Home, Grid3x3, Wind, Shield, Lightbulb, AlertCircle, Building2, Award, Clock,
  Users, CheckCircle2, Wrench, Plug, Hammer, BatteryCharging, Cpu, Sun, HardHat, Sparkles,
};
